<template>
    <div v-if="model && form">
        <rkm-area
            title="Filtros"
            type="fieldset"
            no-margin-top
        >
            <rkm-form
                ref="Form"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="validations.start"
                            :end-validations="validations.end"
                            range
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="autocompleteRequestParams.usuario"
                            :searchFields="fields.autocomplete.usuario"
                            :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                            label="Profissional"
                            placeholder="Digite o nome ou número do conselho profissional"
                            v-model="model.usuario"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Unidade"
                            :options="form.unidades"
                            v-model="model.unidadeId"
                            show-default-option
                            text-field="nomeFantasia"
                            value-field="id"
                            default-option-text="Todas"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            color="secondary"
                            @click="clearForm"
                        >
                            Limpar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="list"
                        >
                            Buscar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="items.length"
            title="Resultado"
            no-margin-top
        >
            <rkm-table
                :fields="tableFields"
                :items="items"
                hide-filters
                hide-pagination
                no-footer-sorting
            >
                <template v-slot:cell(data)="row">
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(dataExportacao)="{ item }">
                    {{ item.dataExportacao }} - {{ item.profissionalExportacao }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="handleEdit(item.id)"
                        color="primary"
                        title="Editar"
                        small
                    >
                        <rkm-icon icon="pen"/>
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item.id)"
                        color="danger"
                        title="Excluir"
                        :disabled="item.exportacao"
                        small
                    >
                        <rkm-icon icon="trash"/>
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { repository, error, formats }  from '@/mixins';
import format from '@/filters/formats'
import { mapActions } from "vuex";
import moment from 'moment';

export default {
    created() {
        this.repositories = {
            atendimentoDomiciliar: this.getConectaSusRepository('atencaoBasica.atendimentoDomiciliar'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
        this.load()
    },
    filters: {
        formatDate: format.formatDate
    },
    data() {
        return {
            form: null,
            model: null,
            items: []
        }
    },
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                },
            }
        },
        validations() {
            return {
                start: {
                    required: true
                },
                end: {
                    required: true
                }
            }
        },
        tableFields() {
            return [
                {
                    key: "data",
                    label: "Data",
                    fixed: true
                },
                {
                    key: "profissional",
                    label: "Profissional",
                    fixed: true
                },
                {
                    key: "cns",
                    label: "CNS",
                    fixed: true
                },
                {
                    key: "unidade",
                    label: "Unidade",
                    fixed: true
                },
                {
                    key: 'dataExportacao',
                    label: 'Exportação',
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.index()
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(valid) {
                        this.setLoading()
                        this.repositories.atendimentoDomiciliar.list({
                            data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                            data_final: moment(this.model.periodo.end).format('YYYY-MM-DD')
                        })
                            .then(({ data }) => {
                                this.items = data
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        clearForm() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.usuario = null
            this.model.unidadeId = null
        },
        getUnidades() {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.getUnidades({
                data_inicial: moment(this.model.periodo.start).format('YYYY-MM-DD'),
                data_final: moment(this.model.periodo.end).format('YYYY-MM-DD'),
                usuario_id: this.model.usuario?.id
            })
                .then(({ data }) => {
                    this.form.unidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEdit(id) {
            this.$router.push({ name: 'atencao-basica-atendimento-domiciliar-create', params: { id } })
        },
        handleDestroy(id) {
            this.setLoading()
            this.repositories.atendimentoDomiciliar.destroy(id)
                .then(() => {
                    this.items = this.items.filter(item => (item.id != id))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    watch: {
        'model.periodo.start': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getUnidades()
            }
        },
        'model.periodo.end': function() {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getUnidades()
            }
        },
        'model.usuario': function() {
            if(this.model.periodo.start && this.model.periodo.end && this.model.usuario) {
                this.getUnidades()
            }
        }
    },
    mixins: [ repository, error, formats ]
}
</script>